import { Controller } from "@hotwired/stimulus"
import PullToRefresh from 'pulltorefreshjs';
import { I18n } from 'i18n-js';
import locales from '../locales.json';

// Connects to data-controller="pulltorefresh"
export default class extends Controller {

  shouldRefresh = true;

  connect() {
    const i18n = new I18n(locales);
    i18n.locale = document.querySelector("meta[name='locale']").content


    PullToRefresh.init({
      instructionsPullToRefresh: i18n.t('pulltorefresh.instructionsPullToRefresh'),
      instructionsReleaseToRefresh: i18n.t('pulltorefresh.instructionsReleaseToRefresh'),
      instructionsRefreshing: i18n.t('pulltorefresh.instructionsRefreshing'),
      shouldPullToRefresh: () => {
        return document.getElementById('content-frame').scrollTop == 0
      }
    })
  }
}
